var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5688_4056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9567 11.0312C14.5063 11.4817 13.6267 12.6735 13.0804 15.44C12.5839 17.9548 12.325 19.3132 12.1973 19.9978C14.1942 19.9517 16.0102 19.1749 17.3864 17.9193C17.1097 15.0818 16.1662 12.8153 14.9603 11.0312H14.9567Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3967 9.85157C17.0737 9.72743 16.0841 10.224 15.623 10.5184C16.8113 12.2599 17.7618 14.4377 18.1342 17.1333C19.2976 15.7429 19.9999 13.9553 19.9999 12.001C19.9999 11.2952 19.9077 10.6106 19.7374 9.95798C19.4253 9.94379 18.9961 9.90832 18.4003 9.85157H18.3967Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26 15.2774C12.8701 12.1916 13.8951 10.8686 14.4626 10.3437C14.0831 9.84714 13.6823 9.38959 13.2744 8.97461C8.96494 11.8192 7.23761 16.7316 6.82617 18.1043C8.06403 19.1542 9.62821 19.8352 11.3449 19.9735C11.4655 19.328 11.7244 17.9553 12.2529 15.2774H12.26Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0055 8.52135C14.3921 8.92569 14.7716 9.36551 15.1334 9.84079C15.6761 9.47546 16.8501 8.86894 18.4746 9.02501C18.9073 9.06757 19.223 9.0924 19.4535 9.10659C19.0953 8.18794 18.5739 7.34733 17.9213 6.63086C17.3467 6.75855 16.1975 7.19481 14.002 8.5249L14.0055 8.52135Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.459 7.09874C12.7711 7.35057 13.0832 7.62368 13.3918 7.91453C15.0305 6.91076 16.3003 6.26168 17.2331 5.9531C16.4812 5.30047 15.6051 4.78617 14.6439 4.44922C14.2821 5.40688 13.3528 6.3539 12.459 7.0952V7.09874Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7823 6.57699C12.5165 5.98112 13.5025 5.06957 13.8466 4.21831C13.2542 4.07998 12.6371 4.00195 12.0022 4.00195C10.8069 4.00195 9.67189 4.26797 8.65039 4.73616C9.42361 5.0873 10.5586 5.67608 11.7823 6.57344V6.57699Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.665 8.37853C12.3671 8.10542 12.0727 7.85359 11.7783 7.62305C11.2144 7.99547 10.7213 8.09833 9.85945 8.27922C9.30614 8.39627 8.54711 8.55588 7.46176 8.85382C4.76613 9.60221 4.09222 11.3827 4.06384 11.4608C4.0532 11.4927 4.03192 11.5246 4.01419 11.553C4.00709 11.702 4 11.8509 4 12.0035C4 14.1174 4.81933 16.0363 6.15651 17.4657C6.75948 15.639 8.58258 11.1557 12.6615 8.38208L12.665 8.37853Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23909 8.05168C8.34572 7.74665 9.11894 7.58349 9.68289 7.4629C10.332 7.32812 10.7044 7.24654 11.0484 7.07629C9.59067 6.04414 8.30315 5.47664 7.71437 5.24609C6.12891 6.25696 4.92297 7.80694 4.35547 9.64068C4.96199 9.04835 5.88063 8.42765 7.23909 8.05168Z",
    fill: "#8C8989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5688_4056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9965,
    fill: "white",
    transform: "translate(4 4.00195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsBook);
export default __webpack_public_path__ + "static/media/SportsBook.f22f6bb8fa243e5f46cceb95c9492f41.svg";
export { ForwardRef as ReactComponent };